import React, { useMemo, useState } from 'react';

export type DialogOpenProps<I, O> = I & {
    callback?: (outputData: O) => void,
}
export type IDialogProps<I, O> = {
    data: DialogOpenProps<I, O>,
    isOpen: boolean,
    handleClose: (outputData: O) => void,
}

export type ICancelDialogResult = {
    isCancel: boolean,
}

export const useDialog = <I, O>(BaseDialogComponent: React.ComponentType<IDialogProps<I, O>>, closeCallback: (outputData: O) => void) => {
    const [isOpen, setIsOpen] = useState(false);
    const [inputData, setInputData] = useState<I>();

    const open = (data: DialogOpenProps<I, O>) => {
        setInputData(data);
        setIsOpen(true);
    }

    const close = () => {
        setIsOpen(false)
    }

    const handleClose = (outputData: O) => {
        closeCallback && closeCallback(outputData);
        close();
    }

    const Component = useMemo(() => () => {
        return (<>
            {isOpen && inputData !== undefined && (<BaseDialogComponent
                data={inputData}
                isOpen={isOpen}
                handleClose={handleClose}
            />)}
        </>);
    }, [isOpen, inputData]);

    return {
        open,
        close,
        Component,
    };
}